export default "__VITE_PUBLIC_ASSET__3fbcae67__"